import React from "react";

const Footer = () => {
  return (
    <footer style={{
      background: "#000",
      borderTop: "1px solid rgba(255,255,255,0.06)",
      padding: "40px 20px",
      textAlign: "center",
    }}>
      <div style={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 900, fontStyle: "italic",
        fontSize: 30,
        letterSpacing: "-1.5px",
        marginBottom: 12,
      }}>
        V<span style={{ color: "#F5C400" }}>S</span>A
      </div>
      <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 13 }}>
        © VSA COMU 2024. Todos os direitos reservados.
      </div>
    </footer>
  );
};

export default Footer;
